import { createColumn, currencyFormatter } from "./createColumn";
import { _CO, _MONTHS } from "../../constants";

/**
 * Generates columns for the 12 fiscal months
 * @param {Array} existingColumns - Optional array of existing columns to detect duplicates
 * @param {Object} options - AG Grid column configuration options
 * @return {Array} Array of generated columns
 */
export const generateMonthColumns = (existingColumns = [], options = {}) => {
  const monthColumns = [];
  const { _custom, ...rest } = options;
  const monthKeyPrefix = _custom?.monthKeyPrefix
    ? _custom.monthKeyPrefix
    : "months";

  for (let i = 1; i <= 12; i++) {
    const fiscalMonthIndex = _CO[i];
    const monthKey = `${monthKeyPrefix}.${fiscalMonthIndex}`;

    // Skip if this month already exists
    if (existingColumns.find((column) => column.field === monthKey)) {
      continue;
    }

    monthColumns.push(
      createColumn({
        headerName: _MONTHS[fiscalMonthIndex],
        field: monthKey,
        editable: true,
        headerClass: "month-header",
        cellDataType: "number",
        type: "rightAligned",
        suppressHeaderMenuButton: true,
        valueFormatter: (params) => {
          return currencyFormatter(params.value, "", 0);
        },
        ...rest,
      }),
    );
  }

  return monthColumns;
};
